import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function RegisterForm() {
  const [error, setError] = useState({});
  const [country, setCountry] = useState([]);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    client_name: "",
    contact_person: "",
    cellphone: "",
    telephone: "",
    email: "",
    address_1: "",
    address_2: "",
    city: "",
    province: "",
    country: "",
    country_code:"",
    code: "",
    company_id: "",
    importers_ref: "",
    tax_ref: "",
    password: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleKeyPress = (e) => {
    if (e.charCode < 48 || e.charCode > 57) e.preventDefault();
  };
  const handleValidate = (value) => {
    let errors = {};
    if (!value.client_name) errors.client_name = "Client Name is required";
    if (!value.contact_person)
      errors.contact_person = "Contact Person is required";
    if (!value.cellphone) errors.cellphone = "Cellphone is required";
    if (!value.email) errors.email = "Email is required";
    if (!value.city) errors.city = "City is required";
    if (!value.province) errors.province = "Province is required";
    if (!value.country) errors.country = "Country is required";
    if (!value.password) errors.password = "Password is required";
    setError(errors);
    return Object.keys(errors).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (handleValidate(formData)) {
      axios
        .post(`${process.env.REACT_APP_BASE_URL}customer-register`, formData)
        .then((res) => {
          toast.success(res.data.message);
          setTimeout(() => navigate("/login"), 1000);
        })
        .catch((err) => {
          const msg = err.response?.data?.message || "Something went wrong.";
          toast.error(msg);
        });
    }
  };
  const getdata = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}GetCountries`)
      .then((res) => setCountry(res.data.data))
      .catch((err) =>
        toast.error(err.response?.data?.message || "Error loading countries")
      );
  };
  useEffect(() => {
    getdata();
  }, []);
  return (
    <>
      <div className=" py-5 loginSec">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-7">
              <div className="card shadow">
                <div className="card-header bg-secondary text-white">
                  <h4 className="mb-0 text-center">Register Form</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label">Client Name*</label>
                        <input
                          type="text"
                          name="client_name"
                          className="form-control rounded"
                          onChange={handleChange}
                        />
                        <small className="text-danger">
                          {error.client_name}
                        </small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Contact Person*</label>
                        <input
                          type="text"
                          name="contact_person"
                          className="form-control"
                          onChange={handleChange}
                        />
                        <small className="text-danger">
                          {error.contact_person}
                        </small>
                      </div>
                      <div className="col-md-6 d-flex">
                           <div className="col-md-4 mb-3">
                                                <label className="form-label">Phone Code</label>
                                                <select
                                                  name="country_code"
                                                 onChange={handleChange}
                                                  className="form-control p-2"
                                                >
                                                  <option>Select...</option>
                                                  {country &&
                                                    country.length > 0 &&
                                                    country.map(
                                                      (item, index) => {
                                                        return (
                                                          <>
                                                            <option
                                                              key={index}
                                                              value={item.id}
                                                            >
                                                              +{item.phonecode} 
                                                            </option>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                </select>
                                              </div>
                                              <div>
                        <label className="form-label">Cellphone*</label>
                        <input
                          type="tel"
                          name="cellphone"
                          className="form-control"
                          maxLength={12}
                          onKeyPress={handleKeyPress}
                          onChange={handleChange}
                        />
                                              </div>
                        <small className="text-danger">{error.cellphone}</small>
                      </div>
                      <div className="col-md-6 d-flex">
                          <div className="col-md-4 mb-3">
                                                <label className="form-label">Phone Code</label>
                                                <select
                                                  name="country_code"
                                                 onChange={handleChange}
                                                  className="form-control p-2"
                                                >
                                                  <option>Select...</option>
                                                  {country &&
                                                    country.length > 0 &&
                                                    country.map(
                                                      (item, index) => {
                                                        return (
                                                          <>
                                                            <option
                                                              key={index}
                                                              value={item.id}
                                                            >
                                                              +{item.phonecode} 
                                                            </option>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                </select>
                                              </div>
                                              <div>

                        <label className="form-label">Telephone</label>
                        <input
                          type="tel"
                          name="telephone"
                          className="form-control"
                          maxLength={12}
                          onKeyPress={handleKeyPress}
                          onChange={handleChange}
                        />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Email*</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          onChange={handleChange}
                        />
                        <small className="text-danger">{error.email}</small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Password*</label>
                        <input
                          type="password"
                          name="password"
                          className="form-control"
                          onChange={handleChange}
                        />
                        <small className="text-danger">{error.password}</small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Address 1</label>
                        <input
                          type="text"
                          name="address_1"
                          className="form-control"
                          onChange={handleChange}
                        />
                      </div>
                        <div className="col-md-6">
                        <label className="form-label">Address 2</label>
                        <input
                          type="text"
                          name="address_2"
                          className="form-control"
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">City*</label>
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          onChange={handleChange}
                        />
                        <small className="text-danger">{error.city}</small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Province*</label>
                        <input
                          type="text"
                          name="province"
                          className="form-control"
                          onChange={handleChange}
                        />
                        <small className="text-danger">{error.province}</small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Country*</label>
                        <select
                          name="country"
                          className="form-select"
                          onChange={handleChange}
                        >
                          <option value="">Select...</option>
                          {country.map((c, idx) => (
                            <option key={idx} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </select>
                        <small className="text-danger">{error.country}</small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Postal Code</label>
                        <input
                          type="text"
                          name="code"
                          className="form-control"
                          onKeyPress={handleKeyPress}
                          onChange={handleChange}
                        />
                        <small className="text-danger">{error.code}</small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Company Reg / ID #</label>
                        <input
                          type="text"
                          name="company_id"
                          className="form-control"
                          onChange={handleChange}
                        />
                        <small className="text-danger">
                          {error.company_id}
                        </small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Importers #</label>
                        <input
                          type="text"
                          name="importers_ref"
                          className="form-control"
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="form-label">Vat / Tax Ref</label>
                        <input
                          type="text"
                          name="tax_ref"
                          className="form-control"
                          onChange={handleChange}
                        />
                      </div>
                    
                      <div className="col-12 text-center mt-4">
                        <button type="submit" className="btn  px-5">
                          Register
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterForm;
